import {
  INDRET_INICIALITZAR,
  INDRET_INTRODUCCIO_ENVIAR_FORMULARI_EN_CURS,
  INDRET_INTRODUCCIO_ENVIAR_FORMULARI_FINALITZADA
} from "../../../actions/actionTypes";

const ESTAT_INICIAL = false;

const peticioEnviarFormulariEnCurs = (state = ESTAT_INICIAL, action) => {
  switch (action.type) {
    case INDRET_INICIALITZAR:
      return ESTAT_INICIAL;

    case INDRET_INTRODUCCIO_ENVIAR_FORMULARI_EN_CURS:
      return true;

    case INDRET_INTRODUCCIO_ENVIAR_FORMULARI_FINALITZADA:
      return false;

    default:
      return state;
  }
};

export default peticioEnviarFormulariEnCurs;
